"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file @preserve */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ let TranslationKey = exports.TranslationKey = /*#__PURE__*/ function(TranslationKey) {
    TranslationKey["apply"] = "apply";
    TranslationKey["brands"] = "brands";
    TranslationKey["categories"] = "categories";
    TranslationKey["clear"] = "clear";
    TranslationKey["clearAllFilters"] = "clearAllFilters";
    TranslationKey["facetNameAndCount"] = "facetNameAndCount";
    TranslationKey["filter"] = "filter";
    TranslationKey["inspirationCorner"] = "inspirationCorner";
    TranslationKey["readNow"] = "readNow";
    TranslationKey["showMore"] = "showMore";
    TranslationKey["showingResultsFor"] = "showingResultsFor";
    TranslationKey["showingXOutOfYProducts"] = "showingXOutOfYProducts";
    TranslationKey["xProducts"] = "xProducts";
    return TranslationKey;
}({});
